import React from 'react'
import MyButton from '../../../../UI/form/MyButton'
import { useState } from 'react'
import { useEffect } from 'react'
import { downloadFile } from '../../../../../helpers/file/FileHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MySpiner from '../../../../UI/spiner/MySpiner'
import { getWriteOffActFileAPI } from '../../../../../api/writeOff/writeOffActAPI'

const WriteOffActDownload = ({ writeOffActId, setOpen }) => {

    const [result, setResult] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        if (result) {
            downloadFile({ result, setResult, setOpen })
        }
    }, [result])

    const download = () => {
        setError('')
        setLoading (true)
        getWriteOffActFileAPI({ writeOffActId }).then(data => {
            setResult(data)
            setLoading (false)
        }).catch(e => {
            setError(responseError(e))
            setLoading (false)
        })
    }

  return (
    <div>
        <p>
            Буде завантажено файл, який необхідно підписати й передати в бухгалтерію
        </p>

        {
            loading ?
                <MySpiner />
            : ''
        }

        <ErrorMessage error={error} />

        <MyButton
            onClick={download}
            disabled={loading ? true : false}
        >
            Завантажити акт
        </MyButton>
    </div>
  )
}

export default WriteOffActDownload